<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M15.429 4H4v11.429h11.429V4zM28 4H16.572v11.429H28V4zM4 16.571h11.429V28H4V16.57zm24 0H16.572V28H28V16.57z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'brandWindowsFilled'
}
</script>
